import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f4f36263911b0014070e55_1786030150640_f215c5aa/fundvault/src/app/insights/duration-risk-higher-for-longer/page.tsx");
